import {Injectable} from "@angular/core";
import {Router} from "@angular/router";

@Injectable({
    providedIn: 'root',
})
export class LinkUtils {

  constructor(
    private router: Router
  ) {
  }

  public getPaymentCardLink(amount: string, isCommissionActive: boolean | undefined): string {
    const currentUrl = window.location.origin + this.router.url.split('?')[0];
    return `${currentUrl}?amount=${amount}&isCommissionActive=${isCommissionActive}`;
  }
}
